'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { Button, Dialog, Select, TextField } from '@/shared/components/ui';
import { ABRANGENCIA_LABEL, type AbrangenciaFeriado, type Feriado, type FeriadoInput } from '@/features/feriados/types/feriadosTypes';
interface FeriadoFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  salvando: boolean;
  ano: number;
  feriadoEdicao: Feriado | null;
  onSalvar: (input: FeriadoInput, id?: string) => Promise<boolean>;
}
const ABRANGENCIAS: AbrangenciaFeriado[] = ['NACIONAL', 'ESTADUAL', 'MUNICIPAL'];
export function FeriadoFormDialog(t0) {
  const $ = _c(68);
  const {
    open,
    onOpenChange,
    salvando,
    ano,
    feriadoEdicao,
    onSalvar
  } = t0;
  const [data, setData] = useState("");
  const [nome, setNome] = useState("");
  const [abrangencia, setAbrangencia] = useState("ESTADUAL");
  const [uf, setUf] = useState("");
  const [municipio, setMunicipio] = useState("");
  const [erro, setErro] = useState(null);
  let t1;
  if ($[0] !== feriadoEdicao?.abrangencia || $[1] !== feriadoEdicao?.data || $[2] !== feriadoEdicao?.municipio || $[3] !== feriadoEdicao?.nome || $[4] !== feriadoEdicao?.uf || $[5] !== open) {
    t1 = () => {
      if (!open) {
        return;
      }
      setData(feriadoEdicao?.data ?? "");
      setNome(feriadoEdicao?.nome ?? "");
      setAbrangencia(feriadoEdicao?.abrangencia ?? "ESTADUAL");
      setUf(feriadoEdicao?.uf ?? "");
      setMunicipio(feriadoEdicao?.municipio ?? "");
      setErro(null);
    };
    $[0] = feriadoEdicao?.abrangencia;
    $[1] = feriadoEdicao?.data;
    $[2] = feriadoEdicao?.municipio;
    $[3] = feriadoEdicao?.nome;
    $[4] = feriadoEdicao?.uf;
    $[5] = open;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== feriadoEdicao || $[8] !== open) {
    t2 = [open, feriadoEdicao];
    $[7] = feriadoEdicao;
    $[8] = open;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  useEffect(t1, t2);
  const exigeUf = abrangencia === "ESTADUAL" || abrangencia === "MUNICIPAL";
  const exigeMunicipio = abrangencia === "MUNICIPAL";
  let t3;
  if ($[10] !== abrangencia || $[11] !== ano || $[12] !== data || $[13] !== exigeMunicipio || $[14] !== exigeUf || $[15] !== feriadoEdicao?.id || $[16] !== municipio || $[17] !== nome || $[18] !== onOpenChange || $[19] !== onSalvar || $[20] !== uf) {
    t3 = async () => {
      if (!data) {
        setErro("Informe a data.");
        return;
      }
      if (Number(data.slice(0, 4)) !== ano) {
        setErro(`A data deve estar no ano ${ano}.`);
        return;
      }
      if (!nome.trim()) {
        setErro("Informe o nome do feriado.");
        return;
      }
      if (exigeUf && !uf.trim()) {
        setErro("Informe a UF.");
        return;
      }
      if (exigeMunicipio && !municipio.trim()) {
        setErro("Informe o munic\xEDpio.");
        return;
      }
      setErro(null);
      const ok = await onSalvar({
        data,
        nome,
        abrangencia,
        uf: exigeUf ? uf : null,
        municipio: exigeMunicipio ? municipio : null
      }, feriadoEdicao?.id);
      if (ok) {
        onOpenChange(false);
      }
    };
    $[10] = abrangencia;
    $[11] = ano;
    $[12] = data;
    $[13] = exigeMunicipio;
    $[14] = exigeUf;
    $[15] = feriadoEdicao?.id;
    $[16] = municipio;
    $[17] = nome;
    $[18] = onOpenChange;
    $[19] = onSalvar;
    $[20] = uf;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  const handleSalvar = t3;
  const t4 = feriadoEdicao ? "Editar feriado" : "Adicionar feriado";
  let t5;
  if ($[22] !== t4) {
    t5 = <span className="text-heading-3 font-heading-3 text-default-font">{t4}</span>;
    $[22] = t4;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  const t6 = `${ano}-01-01`;
  const t7 = `${ano}-12-31`;
  let t8;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = event => setData(event.target.value);
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== data || $[26] !== t6 || $[27] !== t7) {
    t9 = <TextField label="Data"><TextField.Input type="date" value={data} min={t6} max={t7} onChange={t8} /></TextField>;
    $[25] = data;
    $[26] = t6;
    $[27] = t7;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = event_0 => setNome(event_0.target.value);
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== nome) {
    t11 = <TextField label="Nome"><TextField.Input value={nome} placeholder={"ex.: Revolu\xE7\xE3o Constitucionalista"} onChange={t10} /></TextField>;
    $[30] = nome;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  let t13;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = value => {
      setAbrangencia(value as AbrangenciaFeriado);
      setErro(null);
    };
    t13 = ABRANGENCIAS.map(_temp);
    $[32] = t12;
    $[33] = t13;
  } else {
    t12 = $[32];
    t13 = $[33];
  }
  let t14;
  if ($[34] !== abrangencia) {
    t14 = <Select label={"Abrang\xEAncia"} value={abrangencia} onValueChange={t12}>{t13}</Select>;
    $[34] = abrangencia;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== exigeMunicipio || $[37] !== exigeUf || $[38] !== municipio || $[39] !== uf) {
    t15 = exigeUf ? <div className="flex gap-3"><TextField className="w-24" label="UF"><TextField.Input value={uf} placeholder="UF" maxLength={2} onChange={event_1 => setUf(event_1.target.value)} /></TextField>{exigeMunicipio ? <TextField className="flex-1" label={"Munic\xEDpio"}><TextField.Input value={municipio} placeholder={"ex.: S\xE3o Paulo"} onChange={event_2 => setMunicipio(event_2.target.value)} /></TextField> : null}</div> : null;
    $[36] = exigeMunicipio;
    $[37] = exigeUf;
    $[38] = municipio;
    $[39] = uf;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== erro) {
    t16 = erro ? <span className="text-caption font-caption text-error-700">{erro}</span> : null;
    $[41] = erro;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== onOpenChange) {
    t17 = () => onOpenChange(false);
    $[43] = onOpenChange;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== salvando || $[46] !== t17) {
    t18 = <Button variant="neutral-secondary" onClick={t17} disabled={salvando}>Cancelar</Button>;
    $[45] = salvando;
    $[46] = t17;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== handleSalvar) {
    t19 = () => void handleSalvar();
    $[48] = handleSalvar;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== salvando || $[51] !== t19) {
    t20 = <Button variant="brand-primary" loading={salvando} disabled={salvando} onClick={t19}>Salvar</Button>;
    $[50] = salvando;
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  let t21;
  if ($[53] !== t18 || $[54] !== t20) {
    t21 = <div className="flex justify-end gap-2">{t18}{t20}</div>;
    $[53] = t18;
    $[54] = t20;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  let t22;
  if ($[56] !== t11 || $[57] !== t14 || $[58] !== t15 || $[59] !== t16 || $[60] !== t21 || $[61] !== t5 || $[62] !== t9) {
    t22 = <Dialog.Content className="w-[460px] max-w-[95vw]"><div className="flex w-full flex-col gap-4 p-6">{t5}{t9}{t11}{t14}{t15}{t16}{t21}</div></Dialog.Content>;
    $[56] = t11;
    $[57] = t14;
    $[58] = t15;
    $[59] = t16;
    $[60] = t21;
    $[61] = t5;
    $[62] = t9;
    $[63] = t22;
  } else {
    t22 = $[63];
  }
  let t23;
  if ($[64] !== onOpenChange || $[65] !== open || $[66] !== t22) {
    t23 = <Dialog open={open} onOpenChange={onOpenChange}>{t22}</Dialog>;
    $[64] = onOpenChange;
    $[65] = open;
    $[66] = t22;
    $[67] = t23;
  } else {
    t23 = $[67];
  }
  return t23;
}
function _temp(item) {
  return <Select.Item key={item} value={item}>{ABRANGENCIA_LABEL[item]}</Select.Item>;
}